import { Spacer, Option, SelectDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { StatementFrequency } from "../sepaDirectDebitApi";

export const StatementOptions = (props: {
  statementFrequency: Option<StatementFrequency> | null;
  setStatementFrequency: (
    statementFrequency: Option<StatementFrequency> | null,
  ) => void;
  disabledFrequency?: StatementFrequency;
  displayError: boolean;
}) => {
  const { t } = useTranslation();

  const optionsStatementFrequency = useMemo(() => {
    const frequencies: StatementFrequency[] = [
      "WEEKLY",
      "MONTHLY",
      "FORTNIGHTLY",
    ];

    return frequencies.map((frequency) => ({
      value: frequency,
      label: t(`sepaDirectDebit.statementFrequency.${frequency}`),
      disabled:
        props.disabledFrequency === frequency || frequency !== "MONTHLY",
    })) as Option<StatementFrequency>[];
  }, [props.disabledFrequency, t]);

  return (
    <>
      <Spacer y={1.5} />
      <SelectDS
        label={t("sepaDirectDebit.statementOptions.frequency")}
        options={optionsStatementFrequency}
        onChange={(selectedOption) => {
          props.setStatementFrequency(selectedOption ?? null);
        }}
        value={props.statementFrequency}
        allWidth
        error={
          props.displayError && props.statementFrequency === null
            ? t("sepaDirectDebit.statementOptions.frequency.error")
            : undefined
        }
        withoutSpacerBottom
      />
      <Spacer y={1.5} />
    </>
  );
};
